export default __webpack_public_path__ + "static/media/Captain's Boots of the Eastern Sun.4c96fa02.jpg";